<script>
  export let item
  export let base
</script>

<div class="row h-100 no-gutters pad">

  <div class="col-sm-12 my-auto text-center p-5">

    {#if item.images[0]}
      <div
        class="circle"
        style="background-image: url({item.images[0].url});" />
    {:else if item.image}
      <div class="circle" style="background-image: url({item.image});" />
    {:else}
      <div
        class="circle"
        style="background-image: url({base}themes/PlayFair/img/cactus.png);" />
    {/if}

    <h1>
      {#if item.title}{item.title}{:else}Sitefiction{/if}
    </h1>
    <div class="w-50 m-auto">
      <p>
        {#if item.tagline}{item.tagline}{:else}Lorem ipsum dolor site amet.{/if}
      </p>
    </div>
  </div>
</div>
